import component from './WorkspacesSettings.vue'
export default component
